function initThumbnailLeft() {
  const gallery = document.querySelector('media-gallery');
  if (!gallery) return;

  const mainSlider = gallery.querySelector('slider-component:first-of-type');
  const thumbnailSlider = gallery.querySelector('.thumbnail-slider');

  if (!mainSlider || !thumbnailSlider) return;

  gallery.style.cssText = 'display:flex !important; flex-direction:row !important; align-items:flex-start !important; gap:1rem !important;';
  mainSlider.style.cssText = 'flex:1 !important; min-width:0 !important; order:2 !important;';
  thumbnailSlider.style.cssText = 'order:1 !important; flex-shrink:0 !important; width:90px !important;';

  const thumbList = thumbnailSlider.querySelector('.thumbnail-list');
  if (thumbList) {
    thumbList.style.cssText = 'display:flex !important; flex-direction:column !important; flex-wrap:nowrap !important; width:90px !important; overflow-y:auto !important; max-height:600px !important; gap:0.5rem !important;';
  }

  thumbnailSlider.querySelectorAll('.thumbnail-list__item').forEach(item => {
    item.style.cssText = 'width:90px !important; min-width:90px !important; min-height:90px !important; flex-shrink:0 !important;';
  });
}

// Mehrfach versuchen
document.addEventListener('DOMContentLoaded', initThumbnailLeft);
window.addEventListener('load', initThumbnailLeft);
setTimeout(initThumbnailLeft, 500);
setTimeout(initThumbnailLeft, 1500);
